<div *ngIf="isLoading" class="text-center">
  <app-loading-spinner></app-loading-spinner>
</div>
<div *ngIf="!isLoading">
  <div class="container-fluid content-container fh login">
    <img src="/assets/img/logo-prepwell-light.svg" alt="Prepwell logo" class="logo" width="200">
    <h2>Login</h2>

    <div *ngIf="testSite">
      <p class="lead text-center">
        This is a test environment for training purposes.
      </p>
    </div>
    <div class="row">
      <div class="col-lg-4 offset-lg-4 col-sm-6 offset-sm-3">
        <div class="alert alert-danger" *ngIf="error">
          <p>{{ error }}</p>
        </div>
        <form
          #authForm="ngForm"
          (ngSubmit)="onSubmit(authForm)"
          *ngIf="!isLoading"
        >
          <div class="form-group form-floating">
              <input
                type="email"
                id="email"
                class="form-control"
                ngModel
                name="email"
                placeholder="Email"
                required
                email
                autocomplete="off"
              />
              <label for="email">Email Address</label>
          </div>
          <div class="form-group form-floating">
            
              <input
                type="password"
                id="password"
                class="form-control"
                ngModel
                name="password"
                required
                minlength="6"
                placeholder="Password"
                autocomplete="off"
              />
              <label for="password">Password</label>
          </div>

          <button
            type="submit"
            [disabled]="!authForm.valid"
            class="btn btn-primary w-100 btn-block btn-lg"
          >
            Sign in
          </button>
          <hr />
          <div class="row">
            <div class="col">
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="rememberMe"
                  name="rememberMe"
                  ngModel
                  value="1"
                />
                <label class="form-check-label" for="rememberMe"
                  >Remember me</label
                >
              </div>
            </div>
            <div class="col text-end">
              <a [routerLink]="['/forgotten-password']">Forgotten Password <span class="icon-wrap"
                ><fa-icon
                  [icon]="['fal', 'arrow-right']"
                  [fixedWidth]="true"
                ></fa-icon
              ></span></a>
            </div>
          </div>
        </form>
        <hr />
        <!--span
          >Don’t have an account?
          <a [routerLink]="['/register']">Sign up now</a></span
        -->
      </div>
    </div>
    <div class="container-fluid mt-5 inline-footer">
      <div class="row mt-3 mb-3">
        <div class="col-lg-4 offset-lg-4 col-sm-6 offset-sm-3">
          <div class="row">
            <div class="col">© {{today | date :'Y'}} South Tees Hospitals NHS Foundation Trust. All rights reserved.
              <div class="built-by mt-3">Built by <a href="https://www.hark2.com" class="ms-1"><img src="/assets/img/logo-hark2-light.svg" alt="Hark 2" height="24"></a></div></div>
            <div class="col text-end">
              <a [routerLink]="['/terms-and-conditions']"
                >Terms &amp; Conditions</a
              > &nbsp; 
              <a [routerLink]="['/privacy-policy']">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
